import { fetchAuthSession } from 'aws-amplify/auth';
import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios';

function getOrganizationsBaseURL(): string {
    if (import.meta.env.DEV) {
        return '/orgs-api';
    }
    const url = import.meta.env.VITE_ORGANIZATIONS_API_URL;
    if (!url) {
        throw new Error('VITE_ORGANIZATIONS_API_URL is not configured');
    }
    return url;
}

const organizationsBaseURL: string = getOrganizationsBaseURL();

const organizationsClient = axios.create({
    baseURL: organizationsBaseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

organizationsClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        try {
            const session = await fetchAuthSession();
            const accessToken = session.tokens?.accessToken;

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken.toString()}`;
            }
        } catch (error) {
            console.error('Failed to fetch auth session:', error);
        }

        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    },
);

organizationsClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError<{ message?: string }>) => {
        if (error.response) {
            const { data } = error.response;

            let errorMessage = 'An error occurred';
            if (data.message) {
                errorMessage = data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            return Promise.reject(new Error(errorMessage));
        }

        if (error.request) {
            return Promise.reject(new Error('Network error - please check your connection'));
        }

        return Promise.reject(error);
    },
);

export default organizationsClient;
